import dayjs from "dayjs";

import type { TArticle } from "libs/client/src/lib/articles/types";

import type { TArticleCardProps } from "./ArticleCard.config";
import { TArticlePath } from "libs/routes/src/lib/routes.types";

export const transformArticleToArticleCard = (
  article: TArticle,
  path: TArticlePath,
): TArticleCardProps => ({
  author: {
    description: article.author?.role ?? article.author?.bio ?? "",
    image: article.author?.avatar
      ? { ...article.author.avatar, alt: article.author.name }
      : undefined,
    name: article.author?.name ?? article.reviewedBy,
  },
  categories: article.categories.map((category) => ({
    children: category.title,
  })),
  description: article.summary,
  href: path({
    params: {
      slug: article.slug,
    },
  }),
  image: article.previewImage
    ? { ...article.previewImage, alt: article.title }
    : undefined,
  publishedAt: dayjs(article.publishedAt),
  readTime: article.readTime ?? 0,
  title: article.title,
});
